import React from 'react';
import { useTranslation } from 'react-i18next';
import useAppState from '../../AppStore';
import InfoBox from '../../components/infoBox/InfoBox';

const DrawInfoBox = () => {
  const { t } = useTranslation('agisviewer');

  const displayDrawInfoBox = useAppState((state) => state.displayDrawInfoBox);
  const setDisplayDrawInfoBox = useAppState((state) => state.setDisplayDrawInfoBox);

  const activeDrawTool = useAppState((state) => state.activeDrawTool);

  if (!displayDrawInfoBox) {
    return null;
  }

  const getInfoText = () => {
    switch (activeDrawTool) {
      case 'dot':
        return t('draw_info_box_dot');
      case 'line':
        return t('draw_info_box_line');
      case 'polygon':
        return t('draw_info_box_polygon');
      case 'arrow':
        return t('draw_info_box_arrow');
      case 'circle':
        return t('draw_info_box_circle');
      case 'text':
        return t('draw_info_box_text');
      default:
        return '';
    }
  };

  const text = getInfoText();
  if (!text) {
    return null;
  }

  return (
    <InfoBox heading={t('info_box_title')} onClose={() => setDisplayDrawInfoBox(false)}>
      {text}
    </InfoBox>
  );
};

export default DrawInfoBox;
